import React, {useState} from 'react';
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {Helmet} from 'react-helmet';
import {useChangePasswordMutation} from '../../store/builder/inspections.api';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {useTranslation} from '../../hooks/useTranslation';

export default function NewPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [state, setState] = useState({
    password: {
      id: 'password',
      value: null,
      errorShow: false,
      error: t('newPassword.passwordError'),
    },
    confirm_password: {
      id: 'confirm_password',
      value: null,
      errorShow: false,
      error: t('newPassword.passwordError'),
    },
  });
  const token = useSelector(
    state => state.rootReducer.forgotPasswordSlice.verifyToken,
  );
  const [changePassword, {data, error, isSuccess, isLoading, isError}] =
    useChangePasswordMutation();
  const [errorHandler, setErrorHandler] = useErrorHandler([error]);

  const [eye, setEye] = useState(false);
  const [eyeConfirm, setEyeConfirm] = useState(false);

  const inputHandler = e => {
    setState(old => ({
      ...old,
      [e.target.id]: {...old[e.target.id], value: e.target.value},
    }));
  };

  const submitHandler = e => {
    e.preventDefault();
    if (state?.password?.value?.length > 4) {
      if (state.password.value !== state.confirm_password.value) {
        toast.error(t('newPassword.passwordsNotMatch'));
      } else {
        dispatch(setLoader(true));
        let body = {
          verify_token: token,
          password: state.password.value,
          password_confirmation: state.confirm_password.value,
        };
        let config = {
          headers: {
            AppVersion: '1.0.0',
            AppType: 'web',
            DeviceType: 'web',
          },
        };
        axios
          .post(
            `${import.meta.env.VITE_API_URL}auth/set-password`,
            body,
            config,
          )
          .then(res => {
            toast.success(res.data.message);
            navigate('/login');
            dispatch(setLoader(false));
          })
          .catch(err => {
            dispatch(setLoader(false));
            toast.error(err.response.data.message);
          });
      }
    } else {
      toast.error(t('newPassword.passwordLengthError'));
    }
  };

  return (
    <div className='auth'>
      <Helmet>
        <title>{t('newPassword.pageTitle')}</title>
      </Helmet>
      <div className='auth__wrapper'>
        <div className='auth__left'>
          <img src='/assets/forgot-image.png' alt='bg' />
        </div>
        <div className='auth__right'>
          <div className='auth__content forgot'>
            <h1 className='auth__title'>{t('newPassword.title')}</h1>
            <p className='auth__subtitle'>
              {t('newPassword.subtitle')}
            </p>
            <form className='auth__form' onSubmit={submitHandler}>
              <div className='auth__field'>
                <label htmlFor='password' className='auth__label'>
                  {t('newPassword.password')}
                </label>
                <input
                  placeholder={t('newPassword.passwordPlaceholder')}
                  id='password'
                  type={eye ? 'text' : 'password'}
                  className='auth__input'
                  onChange={inputHandler}
                />
                <img
                  className='eye'
                  src={
                    eye ? '/assets/icons/eye-off.svg' : '/assets/icons/eye.svg'
                  }
                  alt='eye'
                  onClick={() => {
                    setEye(!eye);
                  }}
                />
                {state?.password?.errorShow && (
                  <span className='auth__error'>{state?.password?.error}</span>
                )}
              </div>

              <div className='auth__field'>
                <label htmlFor='password' className='auth__label'>
                  {t('newPassword.confirmPassword')}
                </label>
                <input
                  placeholder={t('newPassword.confirmPasswordPlaceholder')}
                  id='confirm_password'
                  type={eyeConfirm ? 'text' : 'password'}
                  className='auth__input'
                  onChange={inputHandler}
                />
                <img
                  className='eye'
                  src={
                    eyeConfirm
                      ? '/assets/icons/eye-off.svg'
                      : '/assets/icons/eye.svg'
                  }
                  alt='eye'
                  onClick={() => {
                    setEyeConfirm(!eyeConfirm);
                  }}
                />
                {state?.password?.errorShow && (
                  <span className='auth__error'>{state?.password?.error}</span>
                )}
              </div>
              <button className='auth__submit'>{t('newPassword.resetPassword')}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
